import home from "./home";
import { qs } from "../utils";

class DiveIn {
    constructor() {
        //
    }

    init() {
        const welcome = qs('[data-cta-welcome]', document)

        welcome.addEventListener('click', (e) => {
            e.preventDefault()
            setTimeout(() => {
                
                home.startExperience()
            }, 2000);
        })
    }
}

export default new DiveIn()
